import React from "react";
import { SELECTED_ELEMENT_COLOR } from "../configuratorConstants";
import { ReactComponent as WindowSvg } from '../../Assets/window.svg';

const WindowRenderer = ({
  element,
  scale,
  wallThickness,
  isSelected,
  windowVisualNeedsFlip,
  highlightForBlindsPlacement = false,
  segmentId,
  parentWallId,
}) => {
  // --- ЗМІНЕНО ---
  // Задаємо фіксовану візуальну ширину вікна (наприклад, 90 см),
  // щоб воно виглядало меншим за стіновий сегмент (який має ширину 1.2 м).
  const VISUAL_WINDOW_WIDTH_M = 0.9;
  const windowElementWidthPx = VISUAL_WINDOW_WIDTH_M * scale;
  // --- КІНЕЦЬ ЗМІНИ ---
  
  const wallThicknessPx = wallThickness * scale;
  const svgRenderHeightPx = wallThicknessPx;

  const svgStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : 
          highlightForBlindsPlacement ? "rgba(40, 167, 69, 0.3)" : "rgba(173, 216, 230, 0.5)",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : 
            highlightForBlindsPlacement ? "#28a745" : "rgba(100, 100, 100, 0.7)",
    strokeWidth: isSelected ? 1.5 / (scale / 50) : 
                 highlightForBlindsPlacement ? 2 / (scale / 50) : 1 / (scale / 50),
    transition: "fill 0.15s ease-in-out, stroke 0.15s ease-in-out",
    filter: highlightForBlindsPlacement ? "drop-shadow(0 0 6px rgba(40, 167, 69, 0.6))" : "none",
  };

  const innerGroupTransform = windowVisualNeedsFlip ? `scale(1, -1)` : "";

  return (
    <g transform={innerGroupTransform}>
      <WindowSvg
        // Атрибут 'x' зі значенням '-половина ширини' ідеально центрує SVG-елемент
        // відносно точки його вставки на стіні.
        x={-windowElementWidthPx * 0.5} 
        y={-svgRenderHeightPx / 2}
        width={windowElementWidthPx}
        height={svgRenderHeightPx * 1.25}
        preserveAspectRatio="none"
        style={svgStyle}
        data-segment-id={segmentId}
        data-parent-wall-id={parentWallId}
        data-window-id={element?.id}
      />
    </g>
  );
};

export default React.memo(WindowRenderer);